// src/pages/FaaliyetlerPage.js
import ResimUpload from "../ResimUpload";
import GlobalStyles from "@mui/material/GlobalStyles";
import { API_BASE } from "../config";

import React, { useMemo, useState, useEffect } from "react";
import {
  List,
  Datagrid,
  BooleanField,
  EditButton,
  TopToolbar,
  CreateButton,
  ExportButton,
  useRecordContext,
  useRefresh,
  useNotify,
  useRedirect,
  ImageField,
  TextField,
  EditBase,
  useEditContext,
  useUpdate,
} from "react-admin";

import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  AddCircle as AddCircleIcon,
  FileDownload as FileDownloadIcon,
} from "@mui/icons-material";

/* -------------------------------------------------------------------------- */
/*                                   TEXTS                                    */
/* -------------------------------------------------------------------------- */

const PLACEHOLDER = "Bu dilde içerik mevcut değildir.";
const ALLOWED = ["tr", "en", "de"];

const T = {
  tr: {
    listTitle: "📌 Faaliyetler",
    newBtn: "Yeni Faaliyet",
    exportBtn: "Dışa Aktar",
    save: "Kaydet",
    saving: "Kaydediliyor…",
    cancel: "Vazgeç",
    editTitle: "Faaliyet Düzenle",
    createdOk: "Faaliyet başarıyla oluşturuldu",
    updatedOk: "Güncelleme başarılı",

    uploadImage: "Görsel Yükle",
    image: "Resim",
    title: "Başlık",
    description: "Açıklama",
    youtube: "YouTube",
    instagram: "Instagram",
    status: "Durum",
    contentLangShort: "İçerik Dili",
    contentLang: "İçerik Dili",
    active: "Aktif",
    passive: "Pasif",
    edit: "Düzenle",
    delete: "Sil",
    confirmDelete: "Silmek istediğinize emin misiniz?",
    emptyTitle: "Faaliyet eklemeye hoş geldiniz",
    emptyDesc:
      "Eklediğiniz faaliyetler mobil uygulamanızda yayınlanacaktır.",
    emptyBtn: "Hemen Faaliyet Ekle",
    langNames: { tr: "Türkçe", en: "İngilizce", de: "Almanca" },
  },
  en: {
    listTitle: "📌 Activities",
    newBtn: "New Activity",
    exportBtn: "Export",
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    editTitle: "Edit Activity",
    createdOk: "Created successfully",
    updatedOk: "Updated successfully",

    uploadImage: "Upload Image",
    image: "Image",
    title: "Title",
    description: "Description",
    youtube: "YouTube",
    instagram: "Instagram",
    status: "Status",
    contentLangShort: "Language",
    contentLang: "Content Language",
    active: "Active",
    passive: "Inactive",
    edit: "Edit",
    delete: "Delete",
    confirmDelete: "Are you sure?",
    emptyTitle: "Welcome",
    emptyDesc: "Items added here will appear in your app.",
    emptyBtn: "Add Activity",
    langNames: { tr: "Turkish", en: "English", de: "German" },
  },
  de: {
    listTitle: "📌 Aktivitäten",
    newBtn: "Neue Aktivität",
    exportBtn: "Exportieren",
    save: "Speichern",
    saving: "Wird gespeichert…",
    cancel: "Abbrechen",
    editTitle: "Aktivität bearbeiten",
    createdOk: "Erfolgreich erstellt",
    updatedOk: "Erfolgreich aktualisiert",

    uploadImage: "Bild hochladen",
    image: "Bild",
    title: "Titel",
    description: "Beschreibung",
    youtube: "YouTube",
    instagram: "Instagram",
    status: "Status",
    contentLangShort: "Sprache",
    contentLang: "Inhaltssprache",
    active: "Aktiv",
    passive: "Inaktiv",
    edit: "Bearbeiten",
    delete: "Löschen",
    confirmDelete: "Sind Sie sicher?",
    emptyTitle: "Willkommen",
    emptyDesc:
      "Elemente erscheinen im Aktivitätenbereich der App.",
    emptyBtn: "Aktivität hinzufügen",
    langNames: { tr: "Türkisch", en: "Englisch", de: "Deutsch" },
  },
};

/* Hook: UI text */
function useUiTexts() {
  const [uiLang, setUiLang] = useState(
    () =>
      (localStorage.getItem("app_lang") || "tr")
        .slice(0, 2)
        .toLowerCase()
  );

  useEffect(() => {
    const sync = () => {
      const l = (localStorage.getItem("app_lang") || "tr")
        .slice(0, 2)
        .toLowerCase();
      setUiLang(ALLOWED.includes(l) ? l : "tr");
    };
    window.addEventListener("app_lang_change", sync);
    return () => window.removeEventListener("app_lang_change", sync);
  }, []);

  return useMemo(() => T[uiLang] || T.tr, [uiLang]);
}

/* -------------------------------------------------------------------------- */
/*                               LIST ACTION BAR                              */
/* -------------------------------------------------------------------------- */

const ListActions = () => {
  const TT = useUiTexts();
  return (
    <TopToolbar
      sx={{
        gap: 1.5,
        width: "100%",
        justifyContent: "flex-end",
      }}
    >
      <CreateButton
        icon={<AddCircleIcon />}
        label={TT.newBtn}
        sx={{
          px: 3,
          py: 1.3,
          bgcolor: "#f59e0b !important",
          color: "#fff !important",
          fontWeight: 800,
          borderRadius: "6px",
        }}
      />
      <ExportButton
        icon={<FileDownloadIcon />}
        label={TT.exportBtn}
        sx={{
          px: 2.2,
          py: 1.1,
          bgcolor: "#2563eb !important",
          color: "#fff !important",
          fontWeight: 800,
          borderRadius: "6px",
        }}
      />
    </TopToolbar>
  );
};

/* -------------------------------------------------------------------------- */
/*                                DELETE BUTTON                               */
/* -------------------------------------------------------------------------- */

const CustomDeleteButton = () => {
  const TT = useUiTexts();
  const refresh = useRefresh();
  const record = useRecordContext();

const remove = async () => {
  if (!window.confirm(TT.confirmDelete)) return;

  const token = localStorage.getItem("token");

  await fetch(`${API_BASE}/faaliyetler/${record.id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });

 

  refresh();
};


  return (
   <button
  onClick={(e) => {
    e.stopPropagation(); // 👈 SATIR CLICK'İ KESER
    remove();
  }}
  style={{
    color: "#fff",
    background: "#ef4444",
    padding: "6px 10px",
    borderRadius: 6,
    border: "1px solid #ef4444",
    fontWeight: 700,
    cursor: "pointer",
  }}
>
  <DeleteIcon fontSize="small" /> {TT.delete}
</button>

  );
};

/* -------------------------------------------------------------------------- */
/*                                TABLE FIELDS                                */
/* -------------------------------------------------------------------------- */

const BaslikField = () => {
  const record = useRecordContext();
  if (!record) return "-";

  let value =
    record.baslik_tr !== PLACEHOLDER && record.baslik_tr
      ? record.baslik_tr
      : record.baslik_en !== PLACEHOLDER && record.baslik_en
      ? record.baslik_en
      : record.baslik_de;

  return <span style={{ fontWeight: 800 }}>{value || "-"}</span>;
};

const DilField = ({ names }) => {
  const record = useRecordContext();
  if (!record) return "-";
  return (
    <span style={{ fontWeight: 700 }}>
      {names[record.dil] || "-"}
    </span>
  );
};

function ShortLink({ source }) {
  const record = useRecordContext();
  if (!record) return "-";

  const url = record[source] || "";
  if (!url) return "-";

  try {
    const u = new URL(url);
    return u.hostname + "/…";
  } catch {
    return url.substring(0, 20) + "…";
  }
}
/* -------------------------------------------------------------------------- */
/*                                EMPTY STATE                                 */
/* -------------------------------------------------------------------------- */

const EmptyState = () => {
  const TT = useUiTexts();
  return (
    <div
      style={{
        width: "100%",
        minHeight: "50vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ textAlign: "center", padding: 32 }}>
        <h2>{TT.emptyTitle}</h2>
        <p>{TT.emptyDesc}</p>
        <CreateButton
          label={TT.emptyBtn}
          icon={<AddCircleIcon />}
          sx={{
            mt: 2,
            px: 3,
            py: 1.35,
            bgcolor: "#f59e0b !important",
            color: "#fff !important",
            fontWeight: 800,
          }}
        />
      </div>
    </div>
  );
};

/* -------------------------------------------------------------------------- */
/*                                   LIST                                     */
/* -------------------------------------------------------------------------- */

export const FaaliyetlerPage = (props) => {
  const TT = useUiTexts();
  return (
    <>
      <GlobalStyles
        styles={{
          "@media (max-width: 768px)": {
            ".faaliyet-edit-grid": {
              gridTemplateColumns: "1fr !important",
            },
            "input,textarea,select": {
              fontSize: "1.1rem !important",
              padding: "14px !important",
            },
          },
        }}
      />

    <List
  {...props}
  title={TT.listTitle}
  actions={<ListActions />}
  empty={<EmptyState />}
  sort={{ field: "id", order: "DESC" }}
>
<Datagrid
  rowClick="edit"
  bulkActionButtons={false}
  sx={{
    "& .RaDatagrid-row": {
      height: { xs: "90px", sm: "75px", md: "60px" },
    },
    "& td": {
      padding: { xs: "6px", sm: "10px" },
      fontSize: { xs: "0.85rem", sm: "0.95rem" },
      maxWidth: "150px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
  }}
>

  {/* RESİM */}
  <ImageField
    source="resim"
    label={TT.image}
    sx={{
      width: "55px",
      "& img": {
        width: 50,
        height: 50,
        objectFit: "cover",
        borderRadius: 8,
      },
    }}
  />

  {/* BAŞLIK */}
  <TextField
    source="baslik_tr"
    label={TT.title}
    sx={{
      fontWeight: 700,
      maxWidth: "130px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }}
  />

  {/* YOUTUBE */}
  <ShortLink source="youtube" label={TT.youtube} />

  {/* INSTAGRAM */}
  <ShortLink source="instagram" label={TT.instagram} />

  {/* DURUM */}
  <BooleanField
    source="aktif"
    label={TT.status}
    sx={{
      textAlign: "center",
      maxWidth: "60px",
    }}
  />

  {/* DİL (SONA ALINDI) */}
  <DilField
    names={TT.langNames}
    sx={{
      textAlign: "center",
      maxWidth: "60px",
    }}
  />

  {/* İŞLEM (SON SÜTUN) */}
  <div
    style={{
      display: "flex",
      gap: 5,
      minWidth: "90px",
    }}
  >
    <EditButton
      icon={<EditIcon />}
      label=""
      sx={{
        bgcolor: "#f59e0b",
        color: "#fff",
        padding: "3px 6px",
        borderRadius: 6,
        minWidth: 40,
      }}
    />

  <CustomDeleteButton />

  </div>

</Datagrid>


</List>

   </>
  );
};

/* -------------------------------------------------------------------------- */
/*                                   EDIT                                     */
/* -------------------------------------------------------------------------- */

function detectPreferredLang(r = {}) {
  return ALLOWED.includes(r.dil) ? r.dil : "tr";
}

function FaaliyetEditView() {
  const TT = useUiTexts();
  const notify = useNotify();
  const redirect = useRedirect();

  const { record, isLoading } = useEditContext();
  const [update, { isLoading: saving }] = useUpdate();

  const [form, setForm] = useState({
    baslik_tr: "",
    baslik_en: "",
    baslik_de: "",
    aciklama_tr: "",
    aciklama_en: "",
    aciklama_de: "",
    resim: "",
    youtube: "",
    instagram: "",
    aktif: true,
    dil: "tr",
  });

  /* Load record */
  useEffect(() => {
    if (!isLoading && record) {
      const preferred = detectPreferredLang(record);

      setForm({
        baslik_tr: record.baslik_tr || "",
        baslik_en: record.baslik_en || "",
        baslik_de: record.baslik_de || "",
        aciklama_tr: record.aciklama_tr || "",
        aciklama_en: record.aciklama_en || "",
        aciklama_de: record.aciklama_de || "",
        resim: record.resim || "",
        youtube: record.youtube || "",
        instagram: record.instagram || "",
        aktif: !!record.aktif,
        dil: preferred,
      });
    }
  }, [isLoading, record]);

  const onChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!record) return;

    const merged = {
      ...record,
      ...form,
      aktif: !!form.aktif,
      dil: form.dil,
    };

    update(
      "faaliyetler",
      { id: record.id, data: merged },
      {
        onSuccess: () => {
          notify(TT.updatedOk, { type: "success" });
          redirect("/faaliyetler");
        },
        onError: () => notify("Hata", { type: "error" }),
      }
    );
  };

  if (isLoading) return <div>Yükleniyor…</div>;

  return (
    <>
      <div className="w-full">
        <form onSubmit={submit} className="w-full bg-white px-6 py-5">
          <div
            className="faaliyet-edit-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 22,
            }}
          >
            {/* SOL */}
            <div className="space-y-4">
              <div>
                <label className="block font-semibold mb-2 text-lg">
                  {TT.title}
                </label>
                <input
                  name={`baslik_${form.dil}`}
                  value={form[`baslik_${form.dil}`] || ""}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      [`baslik_${form.dil}`]: e.target.value,
                    }))
                  }
                  className="w-full border rounded px-3 py-3 text-base"
                />
              </div>

              <div>
                <label className="block font-semibold mb-2 text-lg">
                  {TT.description}
                </label>
                <textarea
                  name={`aciklama_${form.dil}`}
                  value={form[`aciklama_${form.dil}`] || ""}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      [`aciklama_${form.dil}`]: e.target.value,
                    }))
                  }
                  className="w-full border rounded px-3 py-3 text-base"
                  rows={7}
                />
              </div>

              <div>
                <label className="block font-semibold mb-2 text-lg">
                  YouTube
                </label>
                <input
                  name="youtube"
                  value={form.youtube || ""}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-3 text-base"
                />
              </div>

              <div>
                <label className="block font-semibold mb-2 text-lg">
                  Instagram
                </label>
                <input
                  name="instagram"
                  value={form.instagram || ""}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-3 text-base"
                />
              </div>
            </div>

            {/* SAĞ */}
            <div className="space-y-4">
              <div>
                <label className="block font-semibold mb-2 text-lg">
                  {TT.image}
                </label>
                <ResimUpload
                  label={TT.uploadImage}
                  onUpload={(url) =>
                    setForm((p) => ({ ...p, resim: url }))
                  }
                />
                {form.resim && (
                  <img
                    src={form.resim}
                    alt=""
                    className="mt-3 w-full h-40 object-cover rounded border"
                  />
                )}
              </div>

              <div>
                <label className="block font-semibold mb-2 text-lg">
                  {TT.contentLangShort}
                </label>
                <select
                  name="dil"
                  value={form.dil}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-3 text-base"
                >
                  <option value="tr">{T.tr.langNames.tr}</option>
                  <option value="en">{T.tr.langNames.en}</option>
                  <option value="de">{T.tr.langNames.de}</option>
                </select>
              </div>

              <div className="flex gap-4 mt-3">
                <button
                  type="button"
                  onClick={() => redirect("/faaliyetler")}
                  className="w-1/2 py-3 text-white font-bold rounded"
                  style={{ backgroundColor: "#f59e0b" }}
                >
                  {TT.cancel}
                </button>
                <button
                  type="submit"
                  disabled={saving}
                  className="w-1/2 py-3 text-white font-bold rounded"
                  style={{ backgroundColor: "#2563eb" }}
                >
                  {saving ? TT.saving : TT.save}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

/* EDIT WRAPPER */
export const FaaliyetEdit = (props) => (
  <EditBase resource="faaliyetler" {...props}>
    <FaaliyetEditView />
  </EditBase>
);

/* -------------------------------------------------------------------------- */
/*                                   CREATE                                    */
/* -------------------------------------------------------------------------- */

export const FaaliyetCreate = () => {
  const TT = useUiTexts();
  const notify = useNotify();
  const redirect = useRedirect();

  const [form, setForm] = useState({
    baslik_tr: "",
    baslik_en: "",
    baslik_de: "",
    aciklama_tr: "",
    aciklama_en: "",
    aciklama_de: "",
    resim: "",
    youtube: "",
    instagram: "",
    aktif: true,
    dil: "tr",
  });

  const onChange = (e) =>
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  const submit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const body = {
      ...form,
      aktif: !!form.aktif,
    };

    const res = await fetch(`${API_BASE}/faaliyetler`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    if (res.ok) {
      notify(TT.createdOk, { type: "success" });
      redirect("/faaliyetler");
    } else {
      notify("Kayıt başarısız", { type: "error" });
    }
  };

  return (
    <>
      <div className="w-full bg-white px-6 py-5">
        <form onSubmit={submit}>
          <div
            className="faaliyet-edit-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 22,
            }}
          >
            {/* SOL */}
            <div className="space-y-4">
              <div>
                <label className="block font-semibold mb-2 text-lg">
                  {TT.title}
                </label>
                <input
                  name={`baslik_${form.dil}`}
                  value={form[`baslik_${form.dil}`]}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-3 text-base"
                />
              </div>

              <div>
                <label className="block font-semibold mb-2 text-lg">
                  {TT.description}
                </label>
                <textarea
                  name={`aciklama_${form.dil}`}
                  value={form[`aciklama_${form.dil}`]}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-3 text-base"
                  rows={7}
                />
              </div>

              <div>
                <label className="block font-semibold mb-2 text-lg">
                  YouTube
                </label>
                <input
                  name="youtube"
                  value={form.youtube}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-3 text-base"
                />
              </div>

              <div>
                <label className="block font-semibold mb-2 text-lg">
                  Instagram
                </label>
                <input
                  name="instagram"
                  value={form.instagram}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-3 text-base"
                />
              </div>
            </div>

            {/* SAĞ */}
            <div className="space-y-4">
              <div>
                <label className="block font-semibold mb-2 text-lg">
                  {TT.image}
                </label>
                <ResimUpload
                  label={TT.uploadImage}
                  onUpload={(url) =>
                    setForm((p) => ({ ...p, resim: url }))
                  }
                />

                {form.resim && (
                  <img
                    src={form.resim}
                    alt="preview"
                    className="mt-3 w-full h-40 object-cover rounded border"
                  />
                )}
              </div>

              <div>
                <label className="block font-semibold mb-2 text-lg">
                  {TT.contentLangShort}
                </label>
                <select
                  name="dil"
                  value={form.dil}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-3 text-base"
                >
                  <option value="tr">{T.tr.langNames.tr}</option>
                  <option value="en">{T.tr.langNames.en}</option>
                  <option value="de">{T.tr.langNames.de}</option>
                </select>
              </div>

              <div className="flex gap-4 mt-3">
                <button
                  type="button"
                  onClick={() => redirect("/faaliyetler")}
                  className="w-1/2 py-3 text-white font-bold rounded"
                  style={{ backgroundColor: "#f59e0b" }}
                >
                  {TT.cancel}
                </button>

                <button
                  type="submit"
                  className="w-1/2 py-3 text-white font-bold rounded"
                  style={{ backgroundColor: "#2563eb" }}
                >
                  {TT.save}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
